
import CodeInput from '../components/CodeInput';

export default {
  name: 'Home',
  components: {
    CodeInput
  },
  data() {
    let formData = {
      setupHtml: '',
      setupJs: '',
      testJs: '',
      tests: [
        { name: '', code: '' },
        { name: '', code: '' }
      ]
    };

    // @ts-ignore
    if (this.$route.query.testData) {
      try {
        // @ts-ignore
        formData = JSON.parse(decodeURIComponent(this.$route.query.testData));
      } catch (err) {
        console.error(err);
      }
    }

    return {
      status: '',
      runData: '',
      iframeKey: 0,
      iframeHeight: 100,
      formData
    };
  },
  mounted() {
    window.addEventListener('message', this.handleMessage);
  },
  beforeUnmount() {
    window.removeEventListener('message', this.handleMessage);
  },
  methods: {
    deleteTest(index: number): void {
      this.formData.tests.splice(index, 1);
    },
    newTestAfter(index: number): void {
      this.formData.tests.splice(index + 1, 0, { name: '', code: '' });
    },
    runTests(): void {
      this.formData.tests = this.formData.tests.filter(
        test => test.name || test.code
      );

      // @TODO add error handling
      if (!this.formData.tests.length) {
        this.formData.tests = [{ name: '', code: '' }];
        return;
      }

      this.status = 'running';
      this.runData = this.dataUrl;

      // So that we can run multiple times with same data
      this.iframeKey++;

      // @ts-ignore
      this.$router.push({ query: { testData: this.dataUrl } });
    },
    handleMessage(e: MessageEvent): void {
      const data = e.data;

      if (typeof data === 'string' && data.startsWith('new-height ')) {
        const height = data.slice(11);
        try {
          this.iframeHeight = Number(height);
        } catch (err) {
          console.error('Invalid number', err);
        }
      }
    }
  },
  computed: {
    dataUrl(): string {
      return encodeURIComponent(JSON.stringify(this.formData));
    }
  }
};
